import baseRoute from '../baseRoute';

export default `${baseRoute}/material` as const;
